const getHeight = (el: HTMLElement | null) => {
	if (el == null) return 0;
	const rect = el.getBoundingClientRect();
	return rect.height;
};

const sumHeights = (...els: (HTMLElement | string | null)[]) => {
	return els.reduce<number>((sum, el) => {
		if (typeof el == 'string') {
			el = document.querySelector<HTMLElement>(el);
		}

		return sum + getHeight(el);
	}, 0);
};

const scrollToContent = () => {
	const contentPosition = sumHeights('[data-network-header]', '.intro-section');
	window.scrollTo(0, contentPosition);
};

const scrollIfNeeded = () => {
	const introSection = document.querySelector('.intro-section');

	if (introSection !== null && sessionStorage.shouldScrollDown == 'yes') {
		scrollToContent();
	}
};

document.addEventListener('DOMContentLoaded', () => {
	if (!('sessionStorage' in window)) return;

	const links = document.querySelectorAll<HTMLElement>('a[href]');
	links.forEach(link => {
		link.addEventListener('click', () => {
			const inNetworkHeader =
				link.closest<HTMLElement>('[data-network-header]') !== null;
			sessionStorage.shouldScrollDown = inNetworkHeader ? 'no' : 'yes';
		});
	});

	scrollIfNeeded();
});
scrollIfNeeded();
